import { jsxs, jsx } from "react/jsx-runtime";
import { cn } from "../../../lib/utils.js";
import "../shared/quiz-blank.js";
import { KatexText } from "../shared/katex-text.js";
import { QuizResultFeedback } from "../shared/quiz-result-feedback.js";
import { SubmitButton } from "../shared/submit-button.js";
import "react";
import { useTranslation } from "react-i18next";
import "../../../node_modules/.pnpm/hls.js@1.6.15/node_modules/hls.js/dist/hls.js";
import { QuizMedia } from "../shared/quiz-media.js";
import "../../../utils/quiz-parser.js";
import { DifficultyBadge, DebugQuizId } from "../shared/debug-quiz-id.js";
import { useExplanationQuiz } from "../hooks/use-explanation-quiz.js";
import { motion } from "../../../node_modules/.pnpm/framer-motion@11.18.2_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/framer-motion/dist/es/render/components/motion/proxy.js";
function ExplanationStudent({
  quizId,
  quiz,
  onSolve,
  solveResult,
  isViewSolved = false,
  initialAnswers: initialAnswersProp,
  submitLabel,
  hideSubmitButton = false,
  onAnswerChange,
  disableSound = false,
  difficultyLevel
}) {
  const { t } = useTranslation("quiz");
  const {
    answer,
    setAnswer,
    isSolved,
    canSubmit,
    isShowingCorrectAnswers,
    setIsShowingCorrectAnswers,
    handleSubmit
  } = useExplanationQuiz({
    quizId,
    quiz,
    onSolve,
    solveResult,
    isViewSolved,
    initialAnswers: initialAnswersProp,
    onAnswerChange
  });
  return /* @__PURE__ */ jsxs("div", { className: "space-y-6", children: [
    /* @__PURE__ */ jsxs(
      motion.div,
      {
        initial: { opacity: 0, y: -10 },
        animate: { opacity: 1, y: 0 },
        className: "space-y-2",
        children: [
          /* @__PURE__ */ jsxs("div", { className: "inline-flex gap-2 items-center", children: [
            /* @__PURE__ */ jsx("div", { className: "inline-flex gap-2 items-center px-3 py-1 text-sm font-bold text-white bg-[#55C3FF] rounded-lg", children: /* @__PURE__ */ jsx("span", { children: t("types.explanation.label", "서술형") }) }),
            /* @__PURE__ */ jsx(DifficultyBadge, { level: difficultyLevel }),
            /* @__PURE__ */ jsx(DebugQuizId, { quizId })
          ] }),
          /* @__PURE__ */ jsx("h3", { className: "text-2xl font-bold leading-relaxed text-gray-900", children: /* @__PURE__ */ jsx(KatexText, { text: quiz.title }) }),
          /* @__PURE__ */ jsx(QuizMedia, { image: quiz.image, imageMobile: quiz.imageMobile, desmos: quiz.desmos, vars: quiz.vars })
        ]
      }
    ),
    /* @__PURE__ */ jsxs(
      motion.div,
      {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        transition: { delay: 0.1 },
        children: [
          /* @__PURE__ */ jsx(
            "textarea",
            {
              value: answer,
              onChange: (e) => setAnswer(e.target.value),
              disabled: isSolved || isViewSolved,
              placeholder: t("types.explanation.placeholder", "답변을 입력하세요"),
              maxLength: 500,
              rows: 5,
              className: cn(
                "w-full p-4 rounded-2xl border-2 text-2xl font-medium text-gray-900 resize-y transition-all outline-hidden",
                isSolved || isViewSolved ? "bg-gray-50 border-gray-200 cursor-not-allowed" : "bg-white border-[#BBBBBB] focus:border-[#55C3FF] focus:bg-[#DDF3FF] [box-shadow:0px_4px_0px_rgba(0,0,0,0.1)] focus:[box-shadow:0px_4px_0px_rgba(85,195,255,0.3)]"
              )
            }
          ),
          /* @__PURE__ */ jsxs("div", { className: "mt-1 text-right text-sm text-gray-400", children: [
            answer.length,
            "/500"
          ] })
        ]
      }
    ),
    !isSolved && !isViewSolved && !hideSubmitButton && /* @__PURE__ */ jsx(
      SubmitButton,
      {
        onClick: handleSubmit,
        disabled: !canSubmit,
        label: submitLabel
      }
    ),
    isSolved && /* @__PURE__ */ jsx(
      QuizResultFeedback,
      {
        isCorrect: (solveResult == null ? void 0 : solveResult.correct) ?? null,
        show: isSolved,
        disableSound
      }
    ),
    isSolved && (solveResult == null ? void 0 : solveResult.correctAnswers) && solveResult.correctAnswers.length > 0 && /* @__PURE__ */ jsxs(
      motion.div,
      {
        initial: { opacity: 0, y: 10 },
        animate: { opacity: 1, y: 0 },
        className: "p-4 rounded-2xl bg-[#DDF3FF] border border-[#55C3FF]/20",
        children: [
          /* @__PURE__ */ jsx(
            "button",
            {
              onClick: () => setIsShowingCorrectAnswers((v) => !v),
              className: "text-sm font-semibold text-[#55C3FF] hover:text-[#3BA8E8]",
              children: isShowingCorrectAnswers ? t("common.viewMyAnswer", "내 답안") : t("common.viewCorrectAnswer", "모범답안 보기")
            }
          ),
          isShowingCorrectAnswers && /* @__PURE__ */ jsx("div", { className: "mt-2 text-base text-gray-900", children: /* @__PURE__ */ jsx(KatexText, { text: solveResult.correctAnswers.join(", ") }) })
        ]
      }
    )
  ] });
}
export {
  ExplanationStudent
};
//# sourceMappingURL=explanation-student.js.map
